import { IApi } from "./IApi";
import { Observable, Scheduler } from "rxjs";
import { ILoginResonse, IUser } from "../model/ModelTypes";
import { IDataStore, DatabaseKey } from "../repository/IDataStore";
import { isNullOrUndefined } from "util";
import { flatMap, map, catchError } from "rxjs/operators";
import * as moment from 'moment';

export interface IAuthenticationService {
    authenticateUser(): Observable<IUser>;
    login(username: string, password: string,
          organisationName: string,
          organisationCode: string): Observable<IUser>;

}
export class AuthenticationService implements IAuthenticationService {
    
    private api: IApi; 
    private dataStore: IDataStore;   
    constructor(api: IApi, dataStore: IDataStore) {
        this.api = api;
        this.dataStore = dataStore;
    }
    authenticateUser(): Observable<IUser> {
        let user: IUser;
        return this.api.authenticateUser().subscribeOn(Scheduler.async)
            .pipe(
                flatMap(
                    loginResponse => {
                        user = this.createUserFromLoginRespose(loginResponse);
                        return this.dataStore.insertDocument( user , DatabaseKey.user);
                    }
                ),
                catchError(error => {
                    this.dataStore.insertDocument(undefined, DatabaseKey.user);
                    throw error;
                }),
                map( result => user)
            );
    }
    login(username: string, password: string, organisationName: string, organisationCode: string): Observable<IUser> {
        return this.api.login(username, password, organisationName, organisationCode)
        .pipe(
            flatMap(
                loginResponse => {
                    let user = this.createUserFromLoginRespose(loginResponse);
                    return this.dataStore.insertDocument(user, DatabaseKey.user).pipe( 
                        map( item => user)
                     );
                }
            ),
            map( result => {
                return result;
            }),
            catchError(error => {
                this.dataStore.insertDocument(undefined, DatabaseKey.user);
                throw error;
            }),
        );
    }
    private createUserFromLoginRespose(loginResponse: ILoginResonse|undefined): IUser|undefined {
        if (!isNullOrUndefined(loginResponse)) {
            loginResponse.user.lastAuthenticated = moment().toISOString();
            loginResponse.user.accessToken = loginResponse.accessToken;
            loginResponse.user.refreshToken = loginResponse.refreshToken;
            return loginResponse.user;
        } else {
            return undefined;
        }
    }

}



// WEBPACK FOOTER //
// ./src/utility/IAuthenticationService.ts